import { Component, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RATE_LIMIT_BYPASS_ENABLED_KEY } from '@app/api/interceptors/rate-limit-bypass.interceptor';
import { UserConfigService } from '@sb/shared/user-config';
import { environment } from 'src/environments/environment';

import { DevToolsSectionComponent } from './dev-tools-section.component';

@Component({
  selector: 'app-dev-tools-rate-limit',
  template: `
    <app-dev-tools-section title="Rate limiting" storageKey="rateLimit">
      <label class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs hover:bg-hover">
        <input type="checkbox" class="size-3" [(ngModel)]="bypassEnabled" />
        <span>Bypass rate limiting</span>
      </label>

      @if (secretConfigured) {
        <p class="mt-1 px-2 text-xs text-subtle">
          Sends <code>X-RateLimit-Bypass</code> on API requests. Only accepted on dev and acc.
        </p>
      } @else {
        <p class="mt-1 px-2 text-xs text-subtle">
          No bypass secret configured for this environment — the toggle has no effect here.
        </p>
      }
    </app-dev-tools-section>
  `,
  imports: [FormsModule, DevToolsSectionComponent],
})
export class DevToolsRateLimitComponent {
  #userConfig = inject(UserConfigService);

  bypassEnabled = signal(this.#userConfig.get(RATE_LIMIT_BYPASS_ENABLED_KEY, false)());

  secretConfigured = !!environment.rateLimitBypassSecret;

  constructor() {
    effect(() => {
      this.#userConfig.set(RATE_LIMIT_BYPASS_ENABLED_KEY, this.bypassEnabled());
    });
  }
}
